import theme from '../../base';

const autoComplete = {
  background: theme.colors.neutrals.white,
  itemHover: theme.colors.neutrals.gray200,
  text: theme.colors.neutrals.gray700,
  category: theme.colors.neutrals.gray700,
  divider: theme.colors.neutrals.gray300,
  border: theme.colors.neutrals.gray300,
};

export default autoComplete;
